<template>
    <div
        class="step step-payment-details"
        :class="{'plan-error': globalError}"
    >
        <template v-if="globalError">
            <!-- eslint-disable vue/no-v-html -->
            <div
                class="global-error-container"
                v-html="globalError"
            />
            <!-- eslint-enable -->
        </template>
        <template v-else>
            <h2>
                <slot name="header" />
            </h2>
            <p class="billing-title">
                <slot name="billing-plans-title" />
            </p>
            <billing-plans
                :coupon="coupon"
                :upgrade-lifetime="upgradeLifetime"
                @plan-changed="updatePlan"

                @subscription-plans-error="displayPlansError"
            />
            <p class="billing-title billing-info-title">
                <slot name="billing-info-title" />
            </p>
            <card-form
                :active-sites="activeSites"
                :plan-id="activePlanId"
                :skip-registration="skipRegistration"
                :upgrade-user="upgradeUser"
                :upgrade-lifetime="upgradeLifetime"
                :process-lifetime-upgrade="processLifetimeUpgrade"
                @update-coupon="setCoupon"
                @process-to-step="changeRegistrationStep"
            />
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import BillingPlans from './BillingPlans.vue';
import CardForm from './CardForm.vue';

export default {
    components: {
        BillingPlans,
        CardForm,
    },

    props: {
        skipRegistration: {
            type: Boolean,
        },
        upgradeUser: {
            type: Boolean,
            default: false,
        },
        upgradeLifetime: {
            type: Boolean,
            default: false,
        },
        processLifetimeUpgrade: {
            type: Boolean,
            default: false,
        },
        activeSites: {
            type: Number,
            default: 1,
        },
    },

    data: () => ({
        activePlanId: null,
        globalError: null,
        coupon: {
            type: null,
            amount: null,
        },
    }),

    methods: {
        ...mapActions(['updateUser']),

        /**
         * Handle plan change
         *
         * @param {string} id Plan key.
         */
        updatePlan(id) {
            this.activePlanId = id;
        },

        /**
         * Change registration step
         *
         */
        async changeRegistrationStep() {
            await this.updateUser();
            this.$emit('process-to-step');
        },

        /**
         * Sets plans error message
         *
         */
        displayPlansError() {
            this.globalError = 'Something went wrong. Please try again or <a href="mailto:help@fusebox.fm">contact us</a>';
        },

        /**
         * Sets coupon data
         *
         * @param {object} coupon Coupon data.
         */
        setCoupon(coupon) {
            this.coupon = coupon;
        },
    },
};
</script>
